import { useRouteError } from 'react-router-dom';

/**
 * A data router's error element that throws the route's error on, so a render error reaches
 * the error boundary around the router rather than stopping at the router's own screen.
 */
const RethrowRouteError = () => {
  throw useRouteError();
};

export default RethrowRouteError;
